import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';

const model = {
  state: {},
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({
    dispatch: { logisticsAccrualType },
    getState,
  }: {
    dispatch: any;
    getState: any;
  }) => ({
    // 获取计提类型详情
    async postAccrualTypeDetail(params: any) {
      const data = await fetch('/saasmerchant/fsarea/accrualtype/detail', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 计提类型修改/新增
    async postAccrualTypeVerify(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/fsarea/accrualtype/modify', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 删除计提类型
    async postAccrualTypeDelete(accrualTypeId: number, callback: Function) {
      const data = await fetch('/saasmerchant/fsarea/accrualtype/delete', {
        type: 'POST',
        useJson: true,
        params: { accrualTypeId },
      });
      if (data) {
        callback();
      }
    },
  }),
};

export default model;
